import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { IncentiveBody, IncentiveButton, IncentiveContainer, IncentiveLink, IncentivesWrapper, IncentiveTitle, IncentiveSearch, IncentiveSelect, IncentiveSelectItem, SearchLine, StyledCheckbox, RowWrapper } from './Incentives.styled';
import { SubmitButton, SubPageTitle, RevenueWrapper, RemoveButton, StyledForm, AddButton, StyledTextInputAnalysis } from '../../pages/AnalysisPage/AnalysisPage.styled';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as ChevronUp } from '../../assets/chevron-up.svg';
import { ReactComponent as ChevronDown } from '../../assets/chevron-down.svg';
import { assignSearchTerms } from '../../features/incentiveSearch/search';
import { populateInputs, processIncentiveSearch, resetEnableReset } from '../../features/inputs/inputs';
import axios from 'axios';

function Incentives () {
const incentivesApplied = useSelector((state) => state.inputs.value.incentives).filter(incentive => incentive.applied);
const allIncentives = useSelector((state) => state.inputs.value.incentives).filter(incentive => !incentive.applied);
const search = useSelector((state) => state.incentiveSearch.searchInputs);
const utilitiesList = useSelector((state) => state.outputs.utilitiesList);
const inputs = useSelector((state) => state.inputs.value);
const outputs = useSelector((state) => state.outputs.value);
const dispatch = useDispatch();
const token = useSelector((state) => state.token.value);
const sessionId = useSelector((state) => state.sessionId.value);
const [incentivesExpanded, setIncentivesExpanded] = useState(inputs.incentives.map(() => false));
const [allIncentivesExpanded, setAllIncentivesExpanded] = useState(inputs.incentives.map(() => false));

const handleSelectChange = (e, fieldName) => {
   dispatch(assignSearchTerms({...search, [fieldName]: e.target.value}));
}

const handleKeyDown = (e) => {
   if (e.key === 'Enter') {
      e.preventDefault();
      dispatch(assignSearchTerms({...search, searchTerms: [...search.searchTerms, e.target.value]}));
      document.getElementById("searchTextBox").value = '';
   }
}

const handleAddManualIncentive = (e) => {
   e.preventDefault();
   const amount = document.getElementById("incentiveAmount").value.replace('$', '').replace(',', '');
   const title = document.getElementById("incentiveTitle").value;
   const totalCost = outputs.cost.costOneTimeArr.reduce((acc, cost) => acc + cost.amount, 0);
   if (amount !== '' && title !== '') {
      if (!inputs.incentives.some(incentive => incentive.Title === title) && amount <= totalCost) {
         const newIncentive = {
            Title: title,
            amountApplied: Number(amount),
            applied: true,
            index: null,
            frontendID: inputs.incentives.length,
            Type: "User Entered"
         };
         dispatch(populateInputs({...inputs, incentives: [...inputs.incentives, newIncentive]}));
         dispatch(resetEnableReset(true));
         setTimeout(1000, () => {
            setIncentivesExpanded(incentivesApplied.map(() => false));
            setAllIncentivesExpanded(allIncentives.map(() => false));});
      };
      document.getElementById("incentivesForm").reset();
   }
}

const handleSearch = (e) => {
   e.preventDefault();
   if (document.getElementById("searchTextBox").value !== '') {
      const term = document.getElementById("searchTextBox").value;
      document.getElementById("searchTextBox").value = '';
      dispatch(assignSearchTerms({...search, searchTerms: [...search.searchTerms, term]}));
   }
   const params = new URLSearchParams(
      {searchTerms: search.searchTerms, 
         utility: search.utility === "All" ? null : search.utility, 
         stateCode: search.stateCode, 
         state: search.state}
   );
   axios.get(`${process.env.REACT_APP_API_URL}api/incentivesSearch`,
      { params: params,
         headers: 
         { 
         'Authorization': `${token}`, 
         'Content-Type': 'application/json',
         'sessionId': `${sessionId}`
         }
      }
   )
   .then(response => {
      dispatch(processIncentiveSearch(response.data));
   })
   .catch(error => {
      console.error(error);
   });
}

return (
 <IncentivesWrapper>
   <RowWrapper>
      <div>Select or deselect incentives and click "Recalculate" to update the calculations on the ROI tab. The initially selected incentive is estimated to be the most valuable one in your state for this project. Please verify with the incentive 
      providers if you qualify and check which utilities operate in your area. We will be adding more incentives to our list soon. 
      <br /> <br /><b>Please note: </b>You may also be eligible for the federal Alternative Fuel Vehicle Refueling Property Credit (AKA 30C). 
      It can cover up to 30% of the project cost for a maximum of $100,000 per charging port. More details are available 
         on the <a href='https://www.irs.gov/credits-deductions/alternative-fuel-vehicle-refueling-property-credit' target='_blank'>IRS website</a>.</div> 
   </RowWrapper>
    <SubPageTitle>Incentives Applied to Results</SubPageTitle>
    {incentivesApplied.map((incentive, index) => (
      <RowWrapper>
         <StyledCheckbox 
            type="checkbox" 
            checked={inputs.incentives.filter(inputIncentive => inputIncentive["frontendID"] === incentive["frontendID"])[0].applied}
            onChange={(e) => {
               dispatch(populateInputs({...inputs, incentives: inputs.incentives.map((inputIncentive, i) => 
                  inputIncentive["frontendID"] === incentive["frontendID"] ? {...inputIncentive, applied: e.target.checked} : inputIncentive)}));
                  dispatch(resetEnableReset(true));
                  setIncentivesExpanded(incentivesApplied.map(() => false));
                  setAllIncentivesExpanded(allIncentives.map(() => false));
               }}
         ></StyledCheckbox>
         <IncentiveContainer
         onClick={() => setIncentivesExpanded(incentivesExpanded.map((value, i) => i === index ? !value : value))}
         >
               <IncentiveTitle>
                  {incentive.Link ? <IncentiveLink href={incentive.Link}
                     target="_blank"
                  >
                     {incentive.Title}
                  </IncentiveLink> : <div>{incentive.Title}</div>}
                  <IncentiveButton>
                     {incentivesExpanded[index] === true ? <ChevronUp /> : <ChevronDown />}
                  </IncentiveButton>
               </IncentiveTitle>
               {incentivesExpanded[index] === true ? <IncentiveBody expanded>
               <p>Estimated Amount for Project: {incentive.amountApplied ? `$${incentive.amountApplied.toLocaleString(undefined, {maximumFractionDigits: 0})}`: 'Unknown'}</p>
               <p>Source: {incentive.Type === "State"  ? "State of " + incentive.State : incentive.Type === "Utility" ? incentive.Utility : incentive.Type}</p>
               <p>{incentive["Plain Text"]}</p>
            </IncentiveBody> :
            null}
         </IncentiveContainer>
         </RowWrapper>
    ))}
    <SubPageTitle>Add Manual Incentive</SubPageTitle>
    <RowWrapper>
      <div>If you already know of an incentive you will be receiving, please add the total amount you will receive here. This amount will adjust your ROI calculation.</div>
    </RowWrapper>
   <StyledForm 
      width='100%' 
      onSubmit={(e) => handleAddManualIncentive(e)}
      id="incentivesForm"
   >
      <StyledTextInputAnalysis
            id="incentiveAmount"
            placeholder="Total Amount ($)"
            width='15%'
      />
      <StyledTextInputAnalysis
            id="incentiveTitle"
            placeholder="Incentive Title"
            aria-label='Incentive Title'
            width='70%'
      />
      <AddButton type="submit" disabled={document.getElementById('incentiveAmount') == '' || document.getElementById('incentiveTitle') == ''}>Add</AddButton>
      </StyledForm>
   <SubPageTitle>Incentive Search</SubPageTitle>
   <SearchLine>
   <StyledForm width='100%' height='40px' onSubmit={(e) => handleSearch(e, "annual")} id="annualRevenueForm">
      <IncentiveSearch 
         placeholder='Search (e.g. "Rebate")' 
         onKeyDown={handleKeyDown}
         id="searchTextBox"
      ></IncentiveSearch>
      <IncentiveSelect 
            value = {search['utility']}
            onChange={(e) => handleSelectChange(e, 'utility')}
         >
            {utilitiesList.map((prop, index) => (
               <IncentiveSelectItem value={prop} key={index}>{prop}</IncentiveSelectItem>
            ))}
      </IncentiveSelect>
      <AddButton type="submit">Search</AddButton>
   </StyledForm>
   </SearchLine>
   {search.searchTerms.map((term, index) => (
            <RevenueWrapper>
               <RemoveButton onClick={(e) => dispatch(assignSearchTerms({...search, searchTerms: search.searchTerms.filter((termInList) => termInList !== term)}))}>x</RemoveButton>
               <div>{term}</div>
            </RevenueWrapper>
   ))}
   <SubPageTitle>Search Results</SubPageTitle>
   {allIncentives.length > 0 ? allIncentives.map((incentive, index) => (
      <RowWrapper>
         <StyledCheckbox 
         type="checkbox"
         checked={Boolean(inputs.incentives.filter(inputIncentive => inputIncentive["frontendID"] === incentive["frontendID"])[0].applied)}
         onChange={(e) => {
            dispatch(populateInputs({...inputs, incentives: inputs.incentives.map((inputIncentive, i) => 
               inputIncentive["frontendID"] === incentive["frontendID"] ? {...inputIncentive, applied: e.target.checked} : inputIncentive)}));
               dispatch(resetEnableReset(true));
               setIncentivesExpanded(incentivesExpanded.map(() => false));
               setAllIncentivesExpanded(allIncentivesExpanded.map(() => false));
            }}
         ></StyledCheckbox>
         <IncentiveContainer
         onClick={() => setAllIncentivesExpanded(allIncentivesExpanded.map((value, i) => i === index ? !value : value))}
         >
               <IncentiveTitle>
                  {incentive.Link ? <IncentiveLink href={incentive.Link}
                     target="_blank"
                  >
                     {incentive.Title}
                  </IncentiveLink> : <div>{incentive.Title}</div>}
                  <IncentiveButton>
                     {allIncentivesExpanded[index] === true ? <ChevronUp /> : <ChevronDown />}
                  </IncentiveButton>
               </IncentiveTitle>
               {allIncentivesExpanded[index] === true ? <IncentiveBody expanded>
               <p>Source: {incentive.Type === "State"  ? "State of " + incentive.State : incentive.Type === "Utility" ? incentive.Utility : incentive.Type}</p>
               <p>{incentive["Plain Text"]}</p>
            </IncentiveBody> :
            null}
            </IncentiveContainer>
         </RowWrapper>
    )): null}

 </IncentivesWrapper>
)};

Incentives.propTypes = {};

Incentives.defaultProps = {};

export default Incentives;
